import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { compose, map } from 'ramda';
import {
  Container,
  ContentWrapper,
  DateTimeItem,
  DateTimeText,
  DateTimeWrapper,
  Image,
  ImageWrapper,
  Title,
  TitleWrapper,
  TotalAmount,
  TotalTitle,
  TotalWrapper,
} from './bookingCard.styles';
import { Icon, ICON_CALENDAR, ICON_TIME } from '../icon';
import messages from '../../../routes/booking/summary/card/card.messages';
import { EntityRefData } from '../entityRefData';
import { renderWhenTrue } from '../../utils/rendering';

export class BookingCard extends PureComponent {
  static propTypes = {
    renderImageOnce: PropTypes.bool,
    experience: PropTypes.object,
    date: PropTypes.any,
    timeslots: PropTypes.array,
    bookingPrice: PropTypes.number,
    intl: PropTypes.object,
    children: PropTypes.any,
    noImage: PropTypes.bool,
  };

  static defaultProps = {
    renderImageOnce: false,
  };

  renderTimeslots = timeslots =>
    compose(
      map(timeslot => (
        <DateTimeItem key={timeslot.start}>
          <Icon name={ICON_TIME} size={21} />
          <DateTimeText>{this.props.intl.formatMessage(messages.timeslot, timeslot)}</DateTimeText>
        </DateTimeItem>
      ))
    )(timeslots);

  renderImage = renderWhenTrue(() => (
    <ImageWrapper>
      <EntityRefData id={this.props.experience.heroGallery[0]} withoutUpdates={this.props.renderImageOnce}>
        {({ file: { url } }) => <Image src={url} />}
      </EntityRefData>
    </ImageWrapper>
  ));

  render() {
    const { experience, date, children, timeslots, bookingPrice, intl, noImage } = this.props;
    const timezoneDate = moment.unix(date).format('DD MMMM YYYY');

    return (
      <Container noImage={noImage}>
        {this.renderImage(!this.props.noImage)}
        <TitleWrapper>
          <Title>{experience.name}</Title>
          <DateTimeWrapper>
            <DateTimeItem>
              <Icon name={ICON_CALENDAR} size={21} />
              <DateTimeText>{timezoneDate}</DateTimeText>
            </DateTimeItem>
            <div>{this.renderTimeslots(timeslots)}</div>
          </DateTimeWrapper>
        </TitleWrapper>
        <ContentWrapper>{children}</ContentWrapper>
        <TotalWrapper>
          <TotalTitle>{intl.formatMessage(messages.total)}</TotalTitle>
          <TotalAmount>{intl.formatMessage(messages.amount, { totalAmount: bookingPrice })}</TotalAmount>
        </TotalWrapper>
      </Container>
    );
  }
}
